import assert from './assert'

export const workspacePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/overview`
}

export const workspacesPath = () => '/workspaces'

export const createWorkspacePath = () => '/workspaces/new'

export const deleteWorkspacePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/basic/delete`
}

export const settingsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/basic`
}

export const settingsPlanSelectPath = args => {
  assert(args, ['workspaceSlug', 'planId'])
  return `/${args.workspaceSlug}/settings/change-plan/${args.planId}/select`
}

export const settingsPlanConfirmPath = args => {
  assert(args, ['workspaceSlug', 'planId'])
  return `/${args.workspaceSlug}/settings/change-plan/${args.planId}/confirm`
}

export const settingsPlanCompletePath = args => {
  assert(args, ['workspaceSlug', 'planId'])
  return `/${args.workspaceSlug}/settings/change-plan/${args.planId}/thanks`
}

export const settingsPlanDowngradePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/plans/downgrade`
}

export const settingsPlansPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/plans`
}

export const legacySettingsUsagePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/api-usage`
}

export const settingsUsagePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/usage`
}

export const settingsCardPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/card`
}

export const settingsConnectionsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/connections`
}

export const settingsConnectionSetupSelectPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/setup-connection/select`
}

export const settingsConnectionSetupConfigurePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/setup-connection/configure-connection`
}

export const settingsConnectionSetupIdpPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/setup-connection/configure-idp`
}

export const settingsConnectionSetupCompletePath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/setup-connection/complete`
}

export const settingsNotificationsPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/notifications`
}

export const settingsAdvancedPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/advanced`
}

export const settingsPrivacySecurityPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/privacy-security`
}

export const settingsTeamPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/settings/team`
}

export const usageFAQPath = args => {
  const { quota } = args
  if (quota.trackedObjects) {
    return 'https://segment.com/docs/guides/usage-and-billing/how-are-mtus-calculated-by-segment/'
  }
  if (quota.calls || quota.rows) {
    return 'https://segment.com/docs/guides/usage-and-billing/what-is-the-difference-between-an-event-and-an-object/'
  }
}

export const billingDashboardPath = args => {
  assert(args, 'workspaceSlug')
  return `https://billing-dashboard.segment.com/workspace?slug=${args.workspaceSlug}`
}

export const salesPath = () => 'https://segment.com/contact/sales'
